import { OfficeTab } from '@root/globalTypes';
import { kebabToCamelCase } from '@utils/textHelpers';
import { BOTTOM_NAV_JOB_ROUTE_PREFIX, BOTTOM_NAV_PRIMARY, BOTTOM_NAV_SLOTS } from './constants';

export const getRouteTab = (route: string) => kebabToCamelCase(route) as OfficeTab;

export const getBottomNavRoutes = (routes: string[]) => {
  const primary = BOTTOM_NAV_PRIMARY.flatMap((tab) =>
    routes.filter((route) => getRouteTab(route) === tab),
  );
  const rest = routes.filter((route) => !primary.includes(route));
  return [...primary, ...rest].slice(0, BOTTOM_NAV_SLOTS);
};

export const getRouteAliases = (route: string) =>
  getRouteTab(route) === 'jobs' ? [route, BOTTOM_NAV_JOB_ROUTE_PREFIX] : [route];
